








import { mapState } from 'vuex';
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
  computed: mapState('modal', ['visible', 'title', 'bodyComponent', 'errorMessage'])
})
export default class Modal extends Vue {
  private handleCancel(e: any) {
    e.preventDefault();

    this.$store.dispatch('modal/hideModal');
  }
}
